import React from 'react';
import './Header.css';
import logo from '../assets/amul-crafts-logo.svg';
import MotivationBanner from './MotivationBanner';

const Header = () => {
  return (
    <header className="cf-header">
      <div className="cf-header-inner">
        <div className="cf-header-main">
          <div className="cf-header-left">
            <div className="cf-brand-row">
              <div className="cf-logo-wrap">
                <img src={logo} alt="Amul Crafts logo" className="cf-logo-image" />
              </div>
              <div className="cf-brand-text">
                <span className="cf-brand-name">Amul Crafts</span>
                <span className="cf-brand-tagline">Curated courses by Amul Agarwal</span>
              </div>
            </div>
          </div>
          <div className="cf-header-center">
            <h1 className="cf-title">Course Finder</h1>
            <p className="cf-subtitle">Find the next course to level up your skills.</p>
          </div>
        </div>
        <div className="cf-header-right">
          <MotivationBanner compact />
        </div>
      </div>
    </header>
  );
};

export default Header;


